import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M30 10L15 22V29L18.6 24.7",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 18L30 10L26 30L10 18Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgSendOutline);
export default ForwardRef;
